import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import PropTypes from 'prop-types';

 const CenterLoader = ({ text = "Loading..." }) => {
  return (
    <Box
      sx={{
        height: "100vh", // full viewport height
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "background.default",
      }}
    >
      <CircularProgress size={60} thickness={5} />
      {text && (
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mt: 2 }}
        >
          {text}
        </Typography>
      )}
    </Box>
  );
}
CenterLoader.propTypes = {
  text: PropTypes.string,
};

export default CenterLoader